// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"5fe1d743","404":"ce93ef30","498":"8c7f5c60","513":"5948cd66"}[chunkId] + ".chunk.js";
};